@if (isValidImage) {
    <span >
        <a href="javascript:void(0)" (click)="onClick()" style="height: 100%" [style.width.%]="width">
            <img [src]="src" alt='' [style.height]="'auto'" />
        </a>
    </span>
}
@if (busy) {
    <img src="{{localImageLocation}}ajax-loader.gif" class="link-busy" alt="loading">
}
